var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCteDIvoire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_1637)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4_1637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 40C31.0459 40 40.0003 31.0457 40.0003 20C40.0003 8.9543 31.0459 0 20.0002 0C8.95455 0 0.000244141 8.9543 0.000244141 20C0.000244141 31.0457 8.95455 40 20.0002 40Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000244141 20C0.000244141 8.95437 8.95462 0 20.0002 0C31.0459 0 40.0003 8.95437 40.0003 20",
    fill: "#338AF3"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4_1637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10 0H50V40H-10V0Z",
    fill: "#009E60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10 0H30V40H-10V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10 0H10V40H-10V0Z",
    fill: "#F77F00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_1637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4_1637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4_1637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    fill: "white",
    transform: "translate(-10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCteDIvoire);
export default __webpack_public_path__ + "static/media/côte_d_ivoire.3fe5aba2c0cde43ec3903d98b1b0a4c3.svg";
export { ForwardRef as ReactComponent };